import { React, useState, useContext, useEffect } from "react";
import SubHeader from "./SubHeader";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import { MDBBtn, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import Select from "react-select";
import { GlobalContext } from "../../App";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { FaEdit,FaRedo } from "react-icons/fa";
import HoverTooltip from "../../components/global/Tooltip";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function Project() {
  const navigate = useNavigate();
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const params = new URLSearchParams(location?.search);
  var param1 = params.get("param1")
  ? parseInt(atob(params.get("param1")))
  : null;
  const { rolexModuleData, user_id, serialSequence, roles, userProfile } =
    useContext(GlobalContext);
  const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [userStatus, setUserStatus] = useState("All");
  const [projectData, setProjectData] = useState({
    projectTitle: null,
    projectDesc: null,
    projectOwner: [],
    updateId: null,
    projectStatus: { label: 'Active', value: 'Active' },
    projectOwnerId: []
  });
  const [userDataList, setUserDataList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [tempProjectList, setTempProjectList] = useState([]);
  const [filterProject, setFilterProject] = useState({
    projectId: "",
    projectTitle: "",
    createdBy: "",
  });
  const [loading, setLoading] = useState(true); 
   // Handle Error
   const handleError = (error) => {
    setLoading(false); 
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setProjectData({
      projectTitle: null,
      projectDesc: null,
      projectOwner: [],
      updateId: null,
      projectStatus: { label: 'Active', value: 'Active' },
      projectOwnerId: []
    });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
  }

  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }

  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria  =  isSpecialAccess ? '' : userProfile || '';
    axios
      .get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`)
      .then((response, error) => {
        const userDataList = response?.data?.[0]?.user_data?.filter((item) => item?.isActive === "1")?.map((item) => ({ label: item?.name, value: item?.user_id, email: item?.email_id, })) || [];
        setUserDataList(userDataList);
        const userList = response?.data?.[0]?.user_data?.filter( (item) => item?.user_id === user_id )?.[0]?.user_x_project;
        const temp = [...new Set(userList?.filter((item) => item?.project_access === 1 || item?.createdBy === user_id)?.map((data) => data?.project_id))];
        getProjectList(temp); 
        setLoading(false); 
      })
      .catch(handleError);
  };
  // ------------------------------------------------------- Add Project --------------------------------------------
  const postAddProject = (e) => {
    if (
      projectData?.projectTitle === null ||
      projectData?.projectTitle === ""
    ) {
      e.preventDefault();
      toast.error("Level 0 title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      projectData?.projectDesc === null ||
      projectData?.projectDesc === ""
    ) {
      e.preventDefault();
      toast.error("Description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } 
     else if (projectData?.projectOwner?.length <= 0) {
      e.preventDefault();
      toast.error("Please select team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (!projectData?.projectOwnerId?.value) {
      e.preventDefault();
      toast.error("Please select owner first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      !projectData?.projectOwner?.some(
        (owner) => owner.value === projectData?.projectOwnerId?.value
      )
    ) {
      e.preventDefault();
      toast.error("Please select Owner in team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    else {
      // let formData = new FormData();
      // formData.append("user_id", user_id);
      // formData.append("projectId", serialSequence?.[0]?.project_seqence);
      // formData.append("userProfile", JSON?.stringify(userProfile));
      // formData.append("projectData", JSON?.stringify(projectData));
       const params = {
        projectData: projectData,
        user_id: user_id,
        projectId: serialSequence[0]?.project_seqence,
        userProfile:userProfile
      }
      axios
        .post("/postAddProject", params)
        .then((response) => {
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Level 0 already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success(
              `Level 0 is ${
                projectData?.updateId != null ? "updated" : "created"
              } successfully!`,
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
            handleClose();
            getUserData();
          }
        })
        .catch(handleError);
    }
  };

  // -------------------------------------------------------- Get Project List --------------------------------------
  const getProjectList = (projectList) => {
    setLoading(true);
    const ProjectList  = param1 ? param1 : isSpecialAccess ? [] : projectList?.length > 0 ? projectList : [0];
    axios.get(`/getProjectList?ProjectList=${ProjectList}`)
      .then((response) => {
        setProjectList( response?.data?.[0]?.project_data);
        setTempProjectList( response?.data?.[0]?.project_data);
        setLoading(false); 
      })
      .catch(handleError);
  };

  // --------------------------------------------------- Update Project -------------------------------------------
  const UptProject = (project_id) => {
    setModal(!modal);
    for (let i = 0; i < projectList?.length; i++) {
      if (projectList[i]?.project_id === project_id) {
        const OwnerList =
          projectList[i]?.project_x_owner?.map((item) => ({
            label: item?.user_data?.[0]?.name,
            value: item?.user_id,
          })) ?? [];
        setProjectData({
          ...projectData,
          projectTitle: projectList[i]?.project_title,
          projectDesc: projectList[i]?.project_description,
          projectOwner: OwnerList,
          updateId: projectList[i]?.project_id,
          projectStatus: {
            label: projectList[i]?.project_status,
            value: projectList[i]?.project_status,
          },
          projectOwnerId: {
            label: projectList[i]?.project_owner?.[0]?.name,
            value: projectList[i]?.project_owner_id,
          },
        });
      }
    }
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // ---------------------------------------------------------- Project Status list --------------------------------------
  const projectStatusList = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ];
  // -------------------------------------------------------- Filter Project List --------------------------------------
  const filtrerProjectList = (clear) => {
  const filterProjects = tempProjectList?.filter(
      (data) =>
          (!filterProject?.projectId ||
              data?.project_title?.includes(filterProject.projectId) ||
              data?.project_code?.includes(filterProject.projectId)) &&
          (!filterProject?.createdBy ||
              data?.created_user?.[0]?.name?.includes(filterProject.createdBy))
  );

  setProjectList(filterProjects);

  if (clear) {
      handleClose();
  }
};
 // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterProject({
      projectId: "",
      projectTitle: "",
      createdBy: "",
    });
    filtrerProjectList(false);
    setProjectList(tempProjectList);
  };

  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Project",
      operationPerformed: "navigate to project screen",
    };
    axios.post("/postLogHistory", param);
  };

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();   
  }, []);
  return (
    loading ? (
      <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
    ) : (<>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Projects</span>
            </li>
          </>
        }
      />

      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postAddProject}
        filterSubmit={filtrerProjectList}
        titleButton={`${projectData?.updateId ? "Edit" : "Add"} Level 0`}
        showButton={
          rolexModuleData?.find(
            (data) => pathname === data?.description && data?.create === 1
          )||
          roles?.find((data) => data?.role_id === 1001)
            ? true
            : false
        }
        AddUserContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Level 0 Title *</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      value={projectData?.projectTitle || ""}
                      onChange={(e) =>
                        setProjectData({
                          ...projectData,
                          projectTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Team Members *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={projectData?.projectOwner}
                      onChange={(select) =>
                        setProjectData({ ...projectData, projectOwner: select })
                      }
                      options={userDataList}
                      isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Level 0 Owner *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={projectData?.projectOwnerId}
                      onChange={(select) =>
                        setProjectData({
                          ...projectData,
                          projectOwnerId: select,
                        })
                      }
                      options={projectData?.projectOwner}
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectDesc">Description *</Label>
                    <Input
                      type="textarea"
                      id="projectDesc"
                      name="projectDesc"
                      value={projectData?.projectDesc || ""}
                      onChange={(e) =>
                        setProjectData({
                          ...projectData,
                          projectDesc: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="status">Status *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={projectData?.projectStatus}
                      onChange={(select) =>
                        setProjectData({
                          ...projectData,
                          projectStatus: select,
                        })
                      }
                      options={projectStatusList}
                      // isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />{" "}
                  </FormGroup>
                </Col>                    
              </Row>
            </FormGroup>
          </Form>
        }
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
                {userStatus}
              </DropdownToggle>
              <DropdownMenu>
              <DropdownItem onClick={() => setUserStatus("Active")}>Active</DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Inactive")}>Inactive</DropdownItem>

               <DropdownItem onClick={() => setUserStatus("All")}>
                  All
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Level 0 ID/Title</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      placeholder="Search By Level 0 ID or Title"
                      value={filterProject?.projectId || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectId: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterProject?.createdBy || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        }
      />
        {/* <div className="reloadData" style={{margin:10,color:"#199ec9" ,}}>
          <FaRedo onClick={getUserData} title="Refresh Data"  size={20}/>
        </div> */}
      <div id="projectManagement">
        <div className="projectheader">
          {projectList?.length > 0 ? (
            projectList?.filter((data) =>
              userStatus === "All" ? data : data?.project_status === userStatus
            )?.length > 0 ? (
              <MDBTable align="middle" className="projectTable">
                <MDBTableHead>
                  <tr>
                    <th scope="col" style={{ minWidth: "320px" }}>
                      Level 0
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Owner</th>
                    <th
                      scope="col"
                      style={{ minWidth: "220px", whiteSpace: "normal" }}
                    >
                      Team Members
                    </th>
                    <th scope="col">Created On</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Modified On</th>
                    <th scope="col">Modified By</th>
                      <th scope="col"> Action</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {projectList
                    ?.filter((data) =>
                      userStatus === "All"
                        ? data
                        : data?.project_status === userStatus
                    )
                    .map((data) => (
                      <tr className="table-light">
                        <th scope="row">
                          <span className="assignedId">
                            {serialSequence?.[0]?.prefix}-{data?.project_code}
                          </span>{" "}
                          <NavLink
                            a
                            className="d-inline-block ps-2"
                            onClick={() => navigate( data?.isActive === "1"
                            ? `/task?param1=${btoa(
                                data?.project_id
                              )}`
                            : "#")}
                          >
                            {" "}
                            {data?.project_title}{" "}
                          </NavLink>{" "}
                        </th>
                        <td>
                          <div
                            className={
                              "badge " +
                              (data?.project_status).replace(/\s/g, "")
                            }
                          >
                            {data?.project_status}
                          </div>
                        </td>
                        <td>
                          {(data?.project_owner &&
                            data?.project_owner?.[0]?.name) ||
                            " - "}
                        </td>
                        <HoverTooltip
                          arrow
                          title={
                            data?.project_x_owner?.length > 0
                              ? data?.project_x_owner
                                  .map((data) => data?.user_data?.[0]?.name)
                                  .join(", ")
                              : " - "
                          }
                        >
                          <td
                            style={{
                              minWidth: "220px",
                              maxWidth: "250px",
                              webkitLineClamp: "3",
                              webkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {data?.project_x_owner?.length > 0
                              ? data?.project_x_owner
                                  .map((data) => data?.user_data?.[0]?.name)
                                  .join(", ")
                              : " - "}
                          </td>
                        </HoverTooltip>                        
                        <td>
                          {new Date(
                            data?.createdDate.split(" ")?.[0]
                          ).toLocaleDateString("en-TT")}
                        </td>
                        <td>
                          {data?.created_user?.length > 0
                            ? data?.created_user?.[0]?.name
                            : "-"}
                        </td>
                        <td>
                          {new Date(
                            data?.updatedDate.split(" ")?.[0]
                          ).toLocaleDateString("en-TT")}
                        </td>
                        <td>
                          {data?.updated_user?.length > 0
                            ? data?.updated_user?.[0]?.name
                            : "-"}
                        </td>
                        {rolexModuleData?.find(
                          (data) =>
                            pathname === data?.description && data?.update === 1
                        ) ||
                        roles?.find((data) => data?.role_id === 1001) ? (
                          <td onClick={() => UptProject(data?.project_id)}>
                            <MDBBtn
                              color="link"
                              rounded
                              size="sm"
                              className="actionBtn"
                            >
                              <FaEdit />
                            </MDBBtn>
                          </td>
                        ) : <td>-</td>}
                      </tr>
                    ))}
                </MDBTableBody>
              </MDBTable>
            ) : (
              <div className="defaultPlaceholder">
                <img src={projectPlaceholderImg} alt="No Project" />
                <h4 className="defaultPlaceholderText">
                  There are no data under "{userStatus}" status!
                </h4>
              </div>
            )
          ) : (
            <div className="defaultPlaceholder">
              <img src={projectPlaceholderImg} alt="No Project" />
              <h4 className="defaultPlaceholderText">No Records!</h4>
            </div>
          )}
        </div>
      </div>
    </>)
  );
}

export default Project;
